import { Box } from '@mui/material';
import RichCtaButton from '../../elements/RichCtaButton';
import { MarkdownButtonLink } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import linkMapper from '../../../utils/mappers/link';
import { useSectionContext } from '../../sections/utils/SectionContext';

const ButtonLink = ({
  link: _link,
  align,
}: DeepNullToUndefined<MarkdownButtonLink>) => {
  const { config } = useSectionContext();
  const blogHubSlug = config.other?.blogHubSlug ?? 'blog';
  const cta = linkMapper(_link, true, { blogHubSlug });

  if (!cta) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: align ?? 'left', my: 2 }}>
      <RichCtaButton cta={cta} track={{ position: 'markdown_buttonLink' }} />
    </Box>
  );
};

export default ButtonLink;
